import type { ReactNode } from 'react';

import PageHeader
  from '../../pricingJourney/components/PageHeader';

type MarginCenterSpecializedPageHeaderProps = {
  backLabel: string;
  onBack: () => void;
  eyebrow: string;
  title: string;
  description: string;
  meta?: ReactNode;
};

// PRC-032: avisos y planificación de Control comercial con la cabecera común.
export default function MarginCenterSpecializedPageHeader({
  backLabel,
  onBack,
  eyebrow,
  title,
  description,
  meta,
}: MarginCenterSpecializedPageHeaderProps) {
  return (
    <PageHeader
      eyebrow={eyebrow}
      title={title}
      description={description}
      back={{ label: backLabel, onClick: onBack }}
      actions={meta}
      sx={{ mb: 0 }}
    />
  );
}
